﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class AuthorityClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getAll() {
        return this.client.apiAuthoritiesGet();
    }
    get(id) {
        return this.client.apiAuthoritiesByIdGet(id);
    }
    create(authority) {
        return this.client.apiAuthoritiesPost(authority);
    }
    delete(data) {
        return this.client.apiAuthoritiesDelete(data);
    }
    update(id, authority) {
        return this.client.apiAuthoritiesByIdPut(id, authority);
    }
}
exports.AuthorityClient = AuthorityClient;
//# sourceMappingURL=AuthorityClient.js.map